<template>
  <div
    class="con flex flex-w"
    :class="list.length < 3 ? 'jc-start' : list.length < 5 ? 'jc-start' : 'jc-betweet'"
  >
    <!--图书模块-->
    <li
      class="mt-30 pb-20 flex flex-w jc-center point bg-col246"
      :class="boutiqueBookid == index ? 'activetransform' : ''"
      :style="{
        width: 100 / cols - 2 + '%',
        'margin-right': list.length < 3 ? '0.1rem' : list.length < 5 ? '0.1rem' : '',
      }"
      v-for="(item, index) in list"
      :key="index"
      @mouseenter="choseboutiquebook(index)"
      @mouseleave="leaveboutiquebook(index)"
      @click="toDetail(item.id)"
    >
      <div class="imgban mt-25">
        <img class="img" :src="'http://www.cctpress.com/file/' + item.cover" alt="" />
      </div>
      <div class="floatcon bg-col2a" v-if="boutiqueBookid == index">
        <div class="u_name text-center color-white fs-20 text-ellipsis">
          {{ item.author }}
        </div>
        <div class="u_isbn color-white fs-16 flex jc-betweet">
          <span>ISBN:</span>
          <span class="text-ellipsis ml-10">{{ item.isbn }}</span>
        </div>
        <div class="u_date color-white fs-16 flex jc-betweet">
          <span>出版日期:</span>
          <span class="text-ellipsis">{{ item.time }}</span>
        </div>
      </div>

      <div class="name color-fontcol3 fs-18 text-ellipsis2 text-center">
        {{ item.title }}
      </div>
      <div class="info color-red fs-20 text-center">￥{{ item.price }}</div>
    </li>
  </div>
</template>
<script>
export default {
  name: "headers",
  props: {
    list: Array,
    cols: Number,
  },
  data() {
    return {
      boutiqueBookid: 0, //新书推荐的id
    };
  },
  methods: {
    leaveboutiquebook() {
      this.boutiqueBookid = -1;
    },
    choseboutiquebook(index) {
      this.boutiqueBookid = index;
    },
    toDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/bookdetail",
        query: { id: id },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  li {
    transition: all 0.3s ease;
    position: relative;
    .imgban {
      width: 70%;
      height: 220px;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .floatcon {
      width: 100%;
      height: 250px;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0.6;
      z-index: 999;
      .u_name {
        width: 70%;
        margin: auto;
        margin-top: 50px;
      }
      .u_isbn {
        width: 85%;
        margin: auto;
        margin-top: 25px;
      }
      .u_date {
        width: 85%;
        margin: auto;
        margin-top: 10px;
      }
    }
    .name {
      width: 90%;
      height: 50px;
      margin: auto;
      margin-top: 10px;
    }
    .info {
      width: 90%;
      margin: auto;
      margin-top: 10px;
      font-family: "JDZH-Regular", sans-serif;
    }
  }
}
</style>
